import React, { useState } from "react";
import emailjs from "emailjs-com";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [isSent, setIsSent] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setIsSent(false);
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const serviceID = "service_is4jhwb";
    const templateID = "template_up722rf";
    const publicKey = "xkUMDag9VFsECCbtP";

    emailjs.send(serviceID, templateID, formData, publicKey).then(
      (response) => {
        console.log("SUCCESS!", response.status, response.text);
        setIsSent(true);
        setFormData({
          name: "",
          email: "",
          phone: "",
          subject: "",
          message: "",
        });
      },
      (error) => {
        console.log("FAILED...", error);
      }
    );
  };

  return (
    <section className="contact-section" id="contact">
      <div className="contact-grid">
        {/* Αριστερή στήλη: πληροφορίες */}
        <div className="contact-info-block">
          <h2>Επικοινωνία</h2>
          <p className="contact-intro">
            Αν θέλετε να κλείσετε ραντεβού ή να ρωτήσετε κάτι σχετικά με τις
            υπηρεσίες, μπορείτε να συμπληρώσετε τη φόρμα ή να επικοινωνήσετε
            απευθείας:
          </p>

          <div className="contact-info">
            <p>
              <strong>Τηλέφωνο:</strong>{" "}
              <a href="tel:+306983314227">+30 6983314227</a>
            </p>
            <p>
              <strong>Email:</strong>{" "}
              <a href="mailto:sofiadavh@gmail.com">sofiadavh@gmail.com</a>
            </p>
            <p>
              <strong>Τοποθεσία:</strong> Θεσσαλονίκη
            </p>
          </div>

          <p className="contact-note">
            Αν δεν λάβετε απάντηση εντός 1–2 εργάσιμων ημερών, ελέγξτε και τον
            φάκελο ανεπιθύμητης αλληλογραφίας (spam).
          </p>
        </div>

        {/* Δεξιά στήλη: φόρμα */}
        <div className="contact-form-wrapper">
          {isSent && (
            <div className="success-message">
              Το μήνυμά σας στάλθηκε με επιτυχία. Θα επικοινωνήσω μαζί σας
              σύντομα.
            </div>
          )}

          <form onSubmit={handleSubmit} className="minimal-form">
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="name">Ονοματεπώνυμο (*)</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email (*)</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  
                  required
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="phone">Τηλέφωνο (*)</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject">Θέμα (*)</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="message">Μήνυμα (*)</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                
                required
              />
            </div>

            <button type="submit" className="submit-btn">
              Αποστολή μηνύματος
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
